module.exports = __webpack_public_path__ + "static/media/Speech_Bubble.0d920289.png";